import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-data-entry-completion',
  templateUrl: './candidate-data-entry-completion.component.html',
  styleUrls: ['./candidate-data-entry-completion.component.scss']
})
export class CandidateDataEntryCompletionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
